var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"trigger":"click"}},[_c('el-button',{attrs:{"slot":"reference"},slot:"reference"},[_c('fa-icon',{attrs:{"icon":"filter"}}),_vm._v(" Filter ")],1),_c('FilterContent',{on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }